<template>
  <main class="container">
    <div class="referral" :class="{ 'is-invalid': !referral.isValid }">
      <h1 class="page-title">Ready to Sign Up for Bills?</h1>
      <h2 data-testid="referral-message" v-html="referral.message" />

      <button class="btn btn--big" type="submit" @click="goToSignUp">
        {{ referral.isValid ? "Get Started" : "Signup Anyway" }}
      </button>
    </div>

    <div class="benefits">
      <InfoBox>
        <template v-slot:image>
          <CustomerIcon class="fill-brand-blue" />
        </template>
        <template v-slot:title>
          Everyone Joins The Account
        </template>
        <template v-slot>
          No need to pick a chief bill-payer, we’ll give you a link once you
          join to share with your housemates.
        </template>
      </InfoBox>

      <InfoBox>
        <template v-slot:image>
          <CogIcon class="fill-brand-blue" />
        </template>
        <template v-slot:title>
          We Set Up Your Services
        </template>
        <template v-slot>
          Once everyone has joined, we can begin setting up the utilities for
          your house. Sit back, and relax.
        </template>
      </InfoBox>

      <InfoBox>
        <template v-slot:image>
          <ChartIcon class="fill-brand-blue" />
        </template>
        <template v-slot:title>
          Each Pay Your Monthly Share
        </template>
        <template v-slot>
          Avoid being out of pocket and chasing your mates for bill money or
          falling out over unpaid bills!
        </template>
      </InfoBox>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import InfoBox from "@/components/InfoBox";
import CustomerIcon from "@/assets/svg/icon-customer.svg";
import CogIcon from "@/assets/svg/icon-cog.svg";
import ChartIcon from "@/assets/svg/icon-chart.svg";

export default {
  name: "Referral",
  computed: {
    ...mapState(["referral"]),
  },
  methods: {
    goToSignUp() {
      this.$router.push("/");
    },
  },
  created() {
    // Tracking page hit events
    this.trackGoogleEvent("Land on Referral Page", "Get Price", "Referral");

    // check for referral code in url and validate against endpoint
    let referralCode = this.$route.query.ref || localStorage.referralCode;

    this.$store.commit("HIDE_BACK_BTN");

    this.$store.dispatch("getReferralMessage", referralCode);
  },
  components: {
    InfoBox,
    CustomerIcon,
    ChartIcon,
    CogIcon,
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 120rem;
}

.referral {
  h2 {
    font-weight: $font-regular;

    @include media("<medium") {
      text-align: start;
    }
  }
}

.btn--full-width {
  max-width: 260px;
  margin-left: auto;
  margin-right: auto;
}

.benefits {
  display: flex;
  justify-content: center;
  margin-top: 5rem;

  .infobox {
    margin: 2rem 0;

    @include media(">=medium") {
      margin: 0 2rem;
      max-width: 24rem;
    }
  }

  @include media("<medium") {
    flex-direction: column;
    margin-top: 1rem;
  }
}
</style>
